module.exports = __webpack_public_path__ + "static/autostore-c4a7f95951c7e48c7bc19eaf433073cb.jpg";